<template>
  <div class="ma-14 pt-14" id="home">
    <!-- Hero Section -->
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="6">
            <div class="text-center pt-4 ma-4" style="font-weight: 490;">
              <h3 class="text-center" style="color: black;">
                {{ translate('home_1') }}
              </h3>
              <h1 style="color: black; font-size: 50px">
                {{ translate('home_2') }}
              </h1>
              <h1 style="color: #61BB46; font-size: 56px">
                {{ translate('home_3') }}
              </h1>
              <h1 style="color: #61BB46; font-size: 68px">
                {{ translate('home_4') }}
              </h1>
            </div>
            <div class="text-left pl-16 ml-16">
              <p style="color: black">
                {{ translate('home_5') }}<br>
                <span style="color: #61BB46;">sYxpaY</span> <span style="font-weight: 600; font-size: 20px;">{{ translate('now') }}</span>
              </p>
              <h3 style="color: black">{{ translate('download_now') }}</h3>
              <v-row>
                <v-col cols="6" sm="3">
                  <v-img src="@/assets/syxpay/download_google_store.png" />
                </v-col>
                <v-col cols="6" sm="3">
                  <v-img src="@/assets/syxpay/download_app_store.png" />
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img max-width="600px" src="@/assets/syxpay/hero.png" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- One App Section -->
    <v-row>
      <v-col cols="12">
        <v-row class="align-center">
          <v-col cols="12" md="5">
            <v-img max-width="600px" src="@/assets/syxpay/home.png" />
          </v-col>
          <v-col cols="12" md="6">
            <p class="heading" style="color: black; font-size: 48px; font-weight: 700;">
                {{ translate('home_6') }}
              <span style="color: #61BB46">
                {{ translate('home_7') }}
              </span>
            </p>
            <p class="pt-4 ma-4" style="text-align: justify;">
              {{ translate('home_8') }}
            </p>
            <v-row class="pt-4 ma-4">
              <v-col v-for="item in items" :key="item.id" cols="12" sm="4">
                <v-hover v-slot:default="{ hover }">
                  <v-card elevation="10" height="320" width="220" style="height: max-content;"
                    :color="hover ? '#8EFF6C' : '#CDCDCD'" class="rounded-xl">
                    <v-img :src="item.img"></v-img>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            <v-row class="pt-4 ma-4 align-center">
              <v-col cols="12" sm="5">
                <p class="pt-1 ma-1" style="color: black">{{ translate('terdaftar') }}</p>
              </v-col>
              <v-col cols="6" sm="3">
                <v-img max-width="190px" src="@/assets/syxpay/bi.png" />
              </v-col>
              <v-col cols="6" sm="3">
                <v-img max-width="190px" src="@/assets/syxpay/ojk.png" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['translate'],
  data() {
    return {
      dialog: false,
      model: null,
      items: [
        { id: 1, img: require("@/assets/syxpay/home_1.png") },
        { id: 2, img: require("@/assets/syxpay/home_2.png") },
        { id: 3, img: require("@/assets/syxpay/home_3.png") }
      ]
    };
  },
};
</script>

<style scoped>
#home {
  margin: 0 !important;
}

.card-hover {
  transition: background-color 0.3s;
}

.card-hover:hover {
  background-color: rgb(167, 231, 73);
}
@media (max-width: 1024px) {
  .heading {
    font-size: 36px;
    margin-left: 16px;
  }
}

@media (max-width: 768px) {
  .heading {
    font-size: 24px;
    margin-left: 16px;
  }
}

@media (max-width: 600px) {
  .heading {
    font-size: 20px;
    margin-left: 16px;
  }
}
</style>
